import { AbstractPmsApiService } from '../abstract.service';
import { ExpensesPayment, PaymentVoucher, Property } from '../../models';

/**
 * @class ExpensesPaymentPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService}
 */
export class ExpensesPaymentPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/vouchers/expenses-payment(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ExpensesPayment}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ExpensesPayment(attributes);
    }

    /**
     * @param {ExpensesPayment=} payment
     * @param {Property=} property
     * @returns {Promise.<ExpensesPayment>}
     */
    create(payment, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, payment.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ExpensesPayment=} payment
     * @returns {Promise.<ExpensesPayment>}
     */
    update(payment) {

        const url = this.url({
            propertyId: payment.property_id,
            id: payment.id
        });

        return this.http
            .put(url, payment.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {PaymentVoucher=} voucher
     * @param {Property=} property
     * @returns {Promise.<boolean>}
     */
    delete(voucher, property) {

        const url = this.url({
            propertyId: property.id,
            id: voucher.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {PaymentVoucher=} voucher
     * @returns {Promise.<ExpensesPayment>}
     */
    show(voucher, property) {

        const url = this.url({
            propertyId: property.id,
            id: voucher.id,
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/vouchers/expenses-payment.service.js